import { render, staticRenderFns } from "./EditLayout.vue?vue&type=template&id=2ffa55e2&scoped=true"
import script from "./EditLayout.vue?vue&type=script&lang=js"
export * from "./EditLayout.vue?vue&type=script&lang=js"
import style0 from "./EditLayout.vue?vue&type=style&index=0&id=2ffa55e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffa55e2",
  null
  
)

export default component.exports